"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPARK_OPTIONS = exports.DEFAULT_YAXIS_OPTIONS = exports.DEFAULT_XAXIS_OPTIONS = exports.DEFAULT_TOOLTIP_OPTIONS = exports.DEFAULT_TITLE_OPTIONS = exports.DEFAULT_SUBTITLE_OPTIONS = exports.DEFAULT_LEGEND_OPTIONS = exports.DEFAULT_LABEL_OPTIONS = exports.DEFAULT_GRIDLINE_OPTIONS = exports.DEFAULT_FOOTER_OPTIONS = exports.DEFAULT_LEGEND_PADDING = exports.LINE_CHART_MAX_LABEL_SIZE = exports.LABEL_FONT_SIZE = exports.DEFAULT_Y_TYPE = exports.DEFAULT_X_TYPE = exports.DEFAULT_SHOW_METRIC_FOOTNOTES = exports.DEFAULT_SHOW_FOOTER = exports.DEFAULT_LINE_STYLE = exports.DEFAULT_LINE_END_MARKER = exports.DEFAULT_IS_SPARK = exports.DEFAULT_HEIGHT = exports.DEFAULT_FILL_TO_ORIGIN = exports.CHART_PADDING = exports.AUTO_LEGEND_BREAKPOINT = void 0;
const ChartWrapper_1 = require("../../components/ChartWrapper");
const constants_1 = require("../../utilities/constants");
exports.AUTO_LEGEND_BREAKPOINT = 768;
exports.CHART_PADDING = 10;
exports.DEFAULT_FILL_TO_ORIGIN = false;
exports.DEFAULT_HEIGHT = '500';
exports.DEFAULT_IS_SPARK = false;
exports.DEFAULT_LINE_END_MARKER = false;
exports.DEFAULT_LINE_STYLE = 'solid';
exports.DEFAULT_SHOW_FOOTER = true;
exports.DEFAULT_SHOW_METRIC_FOOTNOTES = true;
exports.DEFAULT_X_TYPE = 'years';
exports.DEFAULT_Y_TYPE = 'linear';
exports.LABEL_FONT_SIZE = 14;
exports.LINE_CHART_MAX_LABEL_SIZE = 150;
exports.DEFAULT_LEGEND_PADDING = 20;
exports.DEFAULT_FOOTER_OPTIONS = {
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  footnotes: undefined,
  show: exports.DEFAULT_SHOW_FOOTER,
  showMetricFootnotes: exports.DEFAULT_SHOW_METRIC_FOOTNOTES,
  sources: undefined
};
exports.DEFAULT_GRIDLINE_OPTIONS = {
  color: undefined,
  scrubberColor: 'usa-gray',
  showVerticalLines: false,
  showHorizontalLines: true,
  showVerticalScrubber: false,
  showHorizontalScrubber: false,
  style: undefined
};
exports.DEFAULT_LABEL_OPTIONS = {
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  show: undefined,
  width: undefined
};
exports.DEFAULT_LEGEND_OPTIONS = {
  showTitle: true,
  location: 'top',
  show: undefined,
  fontSize: constants_1.DEFAULT_FONT_SIZE
};
exports.DEFAULT_SUBTITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_SUBTITLE_FONT_SIZE,
  text: undefined
};
exports.DEFAULT_TITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_TITLE_FONT_SIZE,
  text: undefined
};
exports.DEFAULT_TOOLTIP_OPTIONS = {
  color: undefined,
  decimals: undefined,
  show: true,
  showMarker: false,
  showSubtitle: true
};
exports.DEFAULT_XAXIS_OPTIONS = {
  displayRangeMin: undefined,
  displayRangeMax: undefined,
  displayTicks: ['bottom'],
  labelPadding: 10,
  textColor: undefined,
  ticks: undefined,
  type: undefined,
  fontSize: constants_1.DEFAULT_FONT_SIZE
};
exports.DEFAULT_YAXIS_OPTIONS = {
  displayRangeMin: undefined,
  displayRangeMax: undefined,
  displayTicks: ['left'],
  labelPadding: 10,
  textColor: undefined,
  ticks: undefined,
  type: undefined,
  fontSize: constants_1.DEFAULT_FONT_SIZE
};
exports.SPARK_OPTIONS = {
  dataSeriesOptions: {
    endMarker: true,
    annotations: []
  },
  footerOptions: {
    show: false
  },
  gridLineOptions: {
    showVerticalLines: false,
    showHorizontalLines: false,
    showVerticalScrubber: false,
    showHorizontalScrubber: false
  },
  labelOptions: {
    show: false
  },
  legendOptions: {
    showTitle: true,
    location: 'top',
    show: false
  },
  subtitleOptions: {
    text: ''
  },
  titleOptions: {
    text: ''
  },
  tooltipOptions: {
    units: '',
    show: false,
    showMarker: false
  },
  xAxisOptions: {
    displayTicks: []
  },
  yAxisOptions: {
    displayTicks: []
  }
};